module.exports = __webpack_public_path__ + "img/daily-express.67cdffcd.svg";